// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__LoZni","rootSuccess":"CompleteLink_rootSuccess__39xXb","rootFailure":"CompleteLink_rootFailure__2Ibl-","isDisabled":"CompleteLink_isDisabled__2bcku"};